<div class="page-area">
    <div class="row">
        <div class="col-lg-12 col-sm-12 col-xs-12">
            <div class="grace-mainbox">
                <div class="grace-box">
                    <div class="grace-column">
                        <div class="tabledata2">
                            <div class="t-description">
                                <h5>Add/Edit Details</h5>
                            </div>
                            <div class="basic-contbox">
                                <div class="emp-box">
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>Shift Name</h5>
                                        </div>
                                        <div class="emp-input">
                                            <input nz-input placeholder="Shift Name" [(ngModel)]="value" [formControl]="name" />
                                        </div>
                                    </div>
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>Shift Code</h5>
                                        </div>
                                        <div class="emp-input">
                                            <input nz-input placeholder="Shift Code" [(ngModel)]="value" [formControl]="name" />
                                        </div>
                                    </div>
                                </div>
            
                                <div class="emp-box">
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>Shift Time</h5>
                                        </div>
                                        <div class="emp-input">
                                            <input numbersOnly nz-input placeholder="Shift Time" [(ngModel)]="demoValue" />
                                        </div>
                                    </div>
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>To</h5>
                                        </div>
                                        <div class="emp-input">
                                            <input numbersOnly nz-input placeholder="To" [(ngModel)]="demoValue" />
                                        </div>
                                    </div>
                                </div>
            
                                <div class="emp-box">
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>Shift Duration</h5>
                                        </div>
                                        <div class="emp-input">
                                            <input numbersOnly nz-input placeholder="Shift Duration" [(ngModel)]="demoValue" />
                                        </div>
                                    </div>
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>Hours</h5>
                                        </div>
                                        <div class="emp-input">
                                            <label nz-checkbox [(ngModel)]="checked">Hours</label>
                                        </div>
                                    </div>
                                </div>
            
                                <div class="emp-box">
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>Recess Min</h5>
                                        </div>
                                        <div class="emp-input">
                                            <input numbersOnly nz-input placeholder="Recess Min" [(ngModel)]="demoValue" />
                                        </div>
                                    </div>
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5></h5>
                                        </div>
                                        <div class="emp-input">
                                            <label nz-checkbox [(ngModel)]="checked">Flex Recess</label>
                                        </div>
                                    </div>
                                </div>
            
                                <div class="emp-box">
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>Recess From</h5>
                                        </div>
                                        <div class="emp-input">
                                            <input numbersOnly nz-input placeholder="Recess From" [(ngModel)]="demoValue" />
                                        </div>
                                    </div>
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>To</h5>
                                        </div>
                                        <div class="emp-input">
                                            <input numbersOnly nz-input placeholder="To" [(ngModel)]="demoValue" />
                                        </div>
                                    </div>
                                </div>
                                <div class="emp-box">
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>Recess Duration</h5>
                                        </div>
                                        <div class="emp-input">
                                            <input numbersOnly nz-input placeholder="Recess Duration" [(ngModel)]="demoValue" />
                                        </div>
                                    </div>
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>Hours</h5>
                                        </div>
                                    </div>
                                </div>
            
                                <div class="emp-box">
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>min Hrs for Half Day</h5>
                                        </div>
                                        <div class="emp-input">
                                            <input numbersOnly nz-input placeholder="min Hrs for Half Day" [(ngModel)]="demoValue" />
                                        </div>
                                    </div>
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>Hours</h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="emp-box">
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>min Hrs for Full Day</h5>
                                        </div>
                                        <div class="emp-input">
                                            <input numbersOnly nz-input placeholder="min Hrs for Full Day" [(ngModel)]="demoValue" />
                                        </div>
                                    </div>
                                    <div class="basic-cont">
                                        <div class="emp-title">
                                            <h5>Hours</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grace-column">
                        <div class="tabledata2">
                            <div class="t-description">
                                <h5>Shift parameters</h5>
                            </div>
                            <div class="basic-contbox basic-contbox2">
                                <div class="basic-cont basic-cont2">
                                    <div class="emp-title">
                                        <h5>Out Punch Accepted within</h5>
                                    </div>
                                    <div class="emp-input">
                                        <input nz-input placeholder="Punch Accepted" [(ngModel)]="value" [formControl]="name" />
                                    </div>
                                </div>
                                <div class="basic-cont basic-cont2">
                                    <div class="emp-title">
                                        <h5>Time Duration During Two Punches</h5>
                                    </div>
                                    <div class="emp-input">
                                        <input nz-input placeholder="Punches" [(ngModel)]="value" [formControl]="name" />
                                    </div>
                                </div>
                                <div class="basic-cont basic-cont2">
                                    <div class="emp-title">
                                        <h5>Grace Time for Late In</h5>
                                    </div>
                                    <div class="emp-input">
                                        <input nz-input placeholder="Grace Time for Late In" [(ngModel)]="value" [formControl]="name" />
                                    </div>
                                </div>
                                <div class="basic-cont basic-cont2">
                                    <div class="emp-title">
                                        <h5>Grace Time for Late OUT</h5>
                                    </div>
                                    <div class="emp-input">
                                        <input nz-input placeholder="Grace Time for Late OUT" [(ngModel)]="value" [formControl]="name" />
                                    </div>
                                </div>
                                <div class="basic-cont basic-cont2">
                                    <div class="emp-title">
                                        <h5>Grace Time Before Shift Time</h5>
                                    </div>
                                    <div class="emp-input">
                                        <input nz-input placeholder="Grace Time Before Shift Time" [(ngModel)]="value" [formControl]="name" />
                                    </div>
                                </div>
                                <div class="basic-cont basic-cont2">
                                    <div class="emp-title">
                                        <h5>Grace Time After Shift Time</h5>
                                    </div>
                                    <div class="emp-input">
                                        <input nz-input placeholder="Grace Time After Shift Time" [(ngModel)]="value" [formControl]="name" />
                                    </div>
                                </div>
                                <div class="basic-cont basic-cont2">
                                    <div class="emp-title">
                                        <h5>OT Penalty</h5>
                                    </div>
                                    <div class="emp-input">
                                        <input nz-input placeholder="OT Penalty" [(ngModel)]="value" [formControl]="name" />
                                    </div>
                                </div>
                                <div class="basic-cont basic-cont2">
                                    <div class="emp-title">
                                        <h5>Is Daily Grace Minute?</h5>
                                    </div>
                                    <div class="emp-input">
                                        <input nz-input placeholder="Grace Minute" [(ngModel)]="value" [formControl]="name" />
                                    </div>
                                </div>
                                
                                <div class="emp-box">
                                    <div class="basic-cont grace-cont">
                                        <div class="emp-title">
                                            <h5>Daily Grace for early out</h5>
                                        </div>
                                        <div class="emp-input">
                                            <label nz-checkbox [(ngModel)]="checked"></label>
                                        </div>
                                    </div>
                                    <div class="basic-cont grace-cont">
                                        <div class="emp-title">
                                            <h5>Daily Grace for late In</h5>
                                        </div>
                                        <div class="emp-input">
                                            <label nz-checkbox [(ngModel)]="checked"></label>
                                        </div>
                                    </div>
                                </div>
                                <div class="emp-box">
                                    <div class="basic-cont grace-cont">
                                        <div class="emp-title">
                                            <h5>Daily Grace for personal out</h5>
                                        </div>
                                        <div class="emp-input">
                                            <label nz-checkbox [(ngModel)]="checked"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grace-btnbox">
                    <ul>
                        <li><a href="javascript:void(0);">Save</a></li>
                        <li><a href="javascript:void(0);">Clear</a></li>
                        <li><a href="javascript:void(0);">Close</a></li>
                        <li><a href="javascript:void(0);" (dblclick)="open()">Create Shift Group</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-lg-12 col-sm-12 col-xs-12">
            <div class="tabledata">
                <div class="tabletop-description">
                    <div class="t-description">
                        <h5>Shift Master</h5>
                        <a href="#">Print & Export</a>
                    </div>
                </div>
                <nz-table #fixedTable [nzData]="listOfData" [nzSize]="'small'">
                    <thead>
                        <tr>
                            <th>Shift Name</th>
                            <th>Shift Time</th>
                            <th>Shift Code</th>
                            <th>Shift Duration</th>
                            <th>Flex Shift</th>
                            <th>Recess Time</th>
                            <th>Recess Duration</th>
                            <th>Flex Recess</th>
                            <th>Min Hrs HalfDay</th>
                            <th>Min Hrs FullDay</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data">
                            <td>{{ data.name }}</td>
                            <td>{{ data.age }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
</div>


<nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '0px' }"
    [nzMaskClosable]="false" [nzWidth]="747" [nzVisible]="visible"
    [nzTitle]=" (isEdit ? 'Update' : '') + ' Shift Group'" (nzOnClose)="close()">
    <div class="drawer-content">
        <div class="shiftgroup-box">
            <div class="shiftgroup-panel">
                <div class="shiftgroup">
                    <h5>Shift Group Name</h5>
                    <input nz-input placeholder="Shift Group Name" [(ngModel)]="value" [formControl]="name" />
                </div>
                <div class="employee-menu">
                    <ul>
                        <li><a href="javascript:void();"><span></span> Search</a></li>
                        <li><a href="javascript:void();"><span></span> Save</a></li>
                        <li><a href="javascript:void();"><span></span> Clear</a></li>
                        <li><a href="javascript:void();"><span></span>Close</a></li>
                    </ul>
                </div>
            </div>
            <div class="tabledata2">
                <nz-table #fixedTable [nzData]="listOfData" [nzSize]="'small'" >
                    <thead>
                        <tr>
                            <th>Weekday</th>
                            <th>Shift Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data">
                            <td>{{ data.name }}</td>
                            <td>{{ data.age }}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
</nz-drawer>